/*
 * @Description:导出富文本编辑器
 * @Author: zr
 * @Date: 2020-03-30 12:45:04
 * @LastEditors: zr
 * @LastEditTime: 2020-03-30 12:45:40
 */
import KEditor from "./kEditor.vue";
export default KEditor;
